// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2B0a9","content":"styles_content__2cvWH","tableWrap":"styles_tableWrap__JEL24"};